import ConfigurableBackground from './_configurable-background.js'
import ConfigurableText from './_configurable-text.js'
import DateTime from './_date-time.js'
import Market from './_market.js'

export default {
  name: 'BannerMarket',
  values: {
    style: {
      $mixin: [
        {
          configSet: ConfigurableBackground,
        },
      ],
    },
    eventName: {
      margin: '0 0 2px 0',
      text: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
    },
    selectionContainer: {
      margin: '0 6px 0 0',
    },
    sportLeague: {
      padding: '5px 0px 0px 15px',
      delimiter: ' - ',
      textStyles: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
    },
    participants: {
      width: '70%',
      minWidth: '330px',
    },
    startTime: {
      top: '5px',
      right: '5px',
      textStyles: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
    },
    maxSelectionsAmount: 3,
    startTimeFormat: {
      configSet: DateTime,
      configValues: {
        showTodayAndTomorrowLabels: true,
      },
    },
    market: {
      configSet: Market,
      configValues: {
        direction: 'row',
        selectionButton: {
          view: {
            layoutDirection: 'horizontalAlignCenter',
            _mobile_layoutDirection: 'vertical',
            height: '40px',
          },
        },
        container: {
          itemSpacing: '6px',
          style: {
            width: '70%',
            height: '40px',
            _mobile_height: '44px',
            minWidth: '330px',
            flexBasis: '0',
            flexGrow: '0',
          },
        },
        selectionsGroupContainer: {
          style: {
            flexDirection: 'row',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
